import React, { Component } from 'react';
import { connect } from 'react-redux';

import styles from './_styles/VariantLineItem.module.scss';

import * as ddnyActionCreators from '../../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class VariantLineItem extends Component {

	constructor(props) {
	
		super(props);
	
		this.state = {
			deleteConfirm: false,
			deletePending: false,
		};
	}

	setDeleteOpen(val) {
		this.setState({ deleteConfirm: !!val });
	}

	async handleDelete() {
		try {

			this.setState({ deletePending: true });

			await this.props.ddnyDeleteVariant(this.props.variant?.id);
			await this.props.refresh({ showLoading: false });

		} catch(err) {
			this.setState({ deletePending: false });
		}
	}
	
	render() {
		return <div className={styles.VariantLineItem}>
			<div className={styles.variantLiner}>
				<div className={styles.variantCopy}>
					{`${this.props.variant.gold_weight ? `${this.props.variant.gold_weight} ` : ''}${this.props.variant.gold_color}`}
				</div>
				<div className={`${styles.deleteWrapper}`} onClick={() => this.setDeleteOpen(true)}>
					<div className={`${styles.deleteIcon} FlexCenter`}>&times;</div>
				</div>
			</div>
			{this.state.deleteConfirm && (
				<div className={styles.deleteOverlay}>
					{this.state.deletePending
						?	<div className={styles.deleteCopyWrapper}>
								<div className={styles.promptCopy}>{`Deleting...`}</div>
							</div>
						:	<div className={styles.deleteCopyWrapper}>
								<div className={styles.promptCopy}>{`Remove ${this.props.variant.gold_weight ? `${this.props.variant.gold_weight} ` : ''}${this.props.variant.gold_color}?`}</div>
								<div className={styles.confirmCopy} onClick={() => this.handleDelete()}>Delete</div>
								<div className={styles.cancelCopy} onClick={() => this.setDeleteOpen(false)}>Cancel</div>
							</div>
					}
				</div>
			)}
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(VariantLineItem);